<script setup>
import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useLayoutStore } from "@/stores/layout";

const layoutStore = useLayoutStore();
const { enrolmentDialog } = storeToRefs(layoutStore);

const visible = computed({
  get: () => !!enrolmentDialog.value.dialog,
  set: (v) => {
    if (!v) layoutStore.closeEnrolmentDialog();
    else layoutStore.openEnrolmentDialog();
  },
});

const rows = [
  { concern: "0", points: "0", bonus: "0 PHP" },
  { concern: "1", points: "30", bonus: "50 PHP" },
  { concern: "2", points: "50", bonus: "100 PHP" },
  { concern: "3", points: "80", bonus: "150 PHP" },
  { concern: "4", points: "130", bonus: "200 PHP" },
  { concern: "5", points: "210", bonus: "250 PHP" },
  { concern: "6", points: "340", bonus: "300 PHP" },
  { concern: "7", points: "550", bonus: "350 PHP" },
  { concern: "8", points: "890", bonus: "400 PHP" },
  { concern: "9", points: "1440", bonus: "450 PHP" },
  { concern: "10", points: "≥2330", bonus: "500 PHP" },
];
</script>

<template>
  <el-dialog
    v-model="visible"
    title="Top Levels — supplemental policy for top tutors"
    width="800px"
    class="enrolment-dialog"
    align-center
    append-to-body
  >
    <p class="intro">
      Your “enrolment bonus” goes with your entire contribution in trial class conversions. It will
      no longer be affected by your instant (monthly) conversion rate《Top Rotation Scheme》. You
      “Enrolment Levels” decide how much you can get from each student enrolment. Please refer to
      the chart below:
    </p>
    <p class="intro">
      <b>Guidelines:</b><br />
      1.For new tutors, it’s easier to achieve a new top level but it’s somehow harder in the
      beginning to accomplish more trial classes. Just do your best in each trial class, get your
      conversion rate up gradually, with it, you will have more bookings and enrolments.<br />
      2.For experienced tutors, each enrolment means more income. Take it professionally and become
      the TOPest.
    </p>

    <el-table :data="rows" class="common-table" style="width: 100%">
      <el-table-column prop="concern" label="TOP LEVEL" align="center" min-width="100" />
      <el-table-column
        prop="points"
        label="Enrolments to complete"
        align="center"
        min-width="160"
      />
      <el-table-column
        prop="bonus"
        label="Enrolment Bonus (100PHP = 1.9 USD)"
        align="center"
        min-width="220"
      />
    </el-table>
  </el-dialog>
</template>

<style scoped lang="scss">
.intro {
  color: #32397a;
  margin: 0 0 12px;
  line-height: 1.5;
  font-size: 14px;
}
</style>
